import React from 'react'
import Input from '../../../form-control/Input'
import { MdSearch } from 'react-icons/md';
import clsx from 'clsx';

interface IGTableSearch {
    searchPlaceholder?: string;
    searchClasses?: string;
    handleSearchInputChange?: (e: React.ChangeEvent<HTMLInputElement>)=> void;
    handleKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>)=> void;
    handleSubmitSearch?: ()=> void;
}

const GTableSearch = ({searchPlaceholder, searchClasses, handleSearchInputChange, handleKeyPress, handleSubmitSearch}:IGTableSearch) => {
  return (
    <div className={clsx(`"w-full md:min-w-[350px] relative flex items-center rounded-full border border-gray-300 dark:border-darkBg-border`,searchClasses)}>
       <MdSearch
      className="text-[#828282] hover:bg-gray-300 ml-3 size-5  h-[30px] w-[35px] p-[2px] !rounded-full  cursor-pointer "
      onClick={handleSubmitSearch}
    />
    <Input
      type="search"
      id={'search'}
      placeholder={searchPlaceholder}
      onChange={handleSearchInputChange}
      onKeyDown={handleKeyPress}
      className="!rounded-full h-[35px] border w-full !border-none !shadow-none  "
      scrollToFormik={false}
      showRing = {false}
      autoFocus
    />
   
  </div>
  )
}

export default GTableSearch